import React from 'react';

import CloseIcon from '@mui/icons-material/Close';

import { FileName, FileNameLayout, FileSize, StyledDownloadIcon } from 'ui/Feed/File/styles';
import AttachmentIcon from 'ui/Icons/AttachmentVertical';
import { humanFileSize } from 'utils/formatters/file';

import { DownloadLink, EvidenceFileFooter, EvidenceFileLayout, EvidenceFilesList, RemoveButton } from './styles';

export interface EvidenceFileRow {
  key: string;
  filename: string;
  size: number | null;
  url?: string;
  caption?: string;
}

interface EvidenceFilesProps {
  files: EvidenceFileRow[];
  onRemove?: (key: string) => void;
}

const EvidenceFiles: React.FunctionComponent<EvidenceFilesProps> = ({ files, onRemove }) => {
  if (files.length === 0) return null;

  return (
    <EvidenceFilesList data-testid="evidence-files">
      {files.map((file) => (
        <EvidenceFileLayout key={file.key} data-testid={`evidence-file-${file.key}`}>
          <EvidenceFileFooter>
            <AttachmentIcon />
            <FileNameLayout>
              <FileName>{file.filename}</FileName>
              <FileSize>
                {[file.size !== null && humanFileSize(file.size), file.caption].filter(Boolean).join(' · ')}
              </FileSize>
            </FileNameLayout>
            {file.url && (
              <DownloadLink href={file.url} target="_blank" rel="noreferrer" aria-label={`Download ${file.filename}`}>
                <StyledDownloadIcon />
              </DownloadLink>
            )}
            {onRemove && (
              <RemoveButton size="small" aria-label={`Remove ${file.filename}`} onClick={() => onRemove(file.key)}>
                <CloseIcon fontSize="small" />
              </RemoveButton>
            )}
          </EvidenceFileFooter>
        </EvidenceFileLayout>
      ))}
    </EvidenceFilesList>
  );
};

export default EvidenceFiles;
